import Skeleton from '@mui/material/Skeleton';
import { useId } from '../../../../lib/hooks/useId';
import styles from './SkeletonAchievmentsList.module.scss';
import { achievementsListIds } from '../../../../lib/tests/testIds';

const SkeletonAchievment = () => {
  return (
    <div className={styles.container}>
      <Skeleton variant="rounded" className={styles.courseTitle} />
      <div className={styles.infoWrapper}>
        <Skeleton variant="rounded" className={styles.status} />
        <Skeleton variant="rectangular" className={styles.separator} />
        <Skeleton variant="rounded" className={styles.completionDate} />
        <Skeleton variant="rectangular" className={styles.separator} />
        <Skeleton variant="rounded" className={styles.expirationDate} />
      </div>
      <Skeleton variant="rounded" className={styles.link} />
    </div>
  );
};

const SkeletonAchievmentList = () => {
  const id = useId('skeleton-achievment-tile-');

  return (
    <div className={styles.list} data-testid={achievementsListIds.skeletonAchievementsList}>
      {Array.from(new Array(5), (_, i) => i).map(value => (
        <SkeletonAchievment key={`${id}${value}`} />
      ))}
    </div>
  );
};

export default SkeletonAchievmentList;
